import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import axios from 'axios';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import apiBaseUrl from './API'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));


export default function SimpleAccordion() {
  const classes = useStyles();
  const [cname, setCname] = React.useState('');
  const [customerNames, setCustomerNames] = React.useState([{}]);
  const [selectedCustomer, setSelectedCustomer ] = React.useState('');

  const [locationNames, setLocationNames] = React.useState([{}]);
  const [selectedLocation, setSelectedLocation ] = React.useState('');

  const [location, setLocation] = React.useState('');
  const [projectName, setPname] = React.useState('');
  const [projectCode, setPcode] = React.useState('');


  const [projectNames, setProjectNames] = React.useState([{}]);
  const [selectedProject, setSelectedProject ] = React.useState('');

  const [count, setCount] = React.useState(0)

  React.useEffect(() => {
    async function fetchData() {
      const res = await fetch(apiBaseUrl+"/customerNames");
      res
        .json()
        .then(res =>  setCustomerNames(res))
        .catch();
    }
    fetchData();
  },[count]);

  React.useEffect(() => {

    async function fetchData() {
      const res = await fetch(apiBaseUrl+'/customerNamesLocation?cid='+selectedCustomer);
      res
        .json()
        .then(res =>  setLocationNames(res))
        .catch();
    }
   
    fetchData();  
  },[count, selectedCustomer]);


  React.useEffect(() => {

   
    async function fetchData() {
      const res = await fetch(apiBaseUrl+'/projectNames?cid='+selectedCustomer+'&lid='+selectedLocation);
      res
        .json()
        .then(res =>  setProjectNames(res))
        .catch();
    }
   
    fetchData();
  },[count]);

  const handleClick = e => {
    e.preventDefault();
  
     console.log("payload cc")
     var payload={
     "cname": cname,
    }
     axios.post(apiBaseUrl+'/addCustomerName', payload)
    .then(function (response) {
      console.log(response);
      if(response.data.code === 200){
         console.log("add customer successfull");
            setCount(count => count+1);
      }
      else{
        console.log("some error ocurred",response.data.code);
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  
 };

 const handleClick1 = e => {
    e.preventDefault();
  
     console.log("payload cc")
     var payload={
     "cid": selectedCustomer,
     "location": location
    }
     axios.post(apiBaseUrl+'/addLocation', payload)
    .then(function (response) {
      console.log(response);
      if(response.data.code === 200){
         console.log("add customer successfull");
         setCount(count => count+1);
      }
      else{
        console.log("some error ocurred",response.data.code);
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  
 };

 const handleClick2 = e => {
    e.preventDefault();
  
     console.log("payload PP")
     var payload={
     "cid": selectedCustomer,
     "lid": selectedLocation,
     "project_name": projectName
    }
     axios.post(apiBaseUrl+'/addProjectName', payload)
    .then(function (response) {
      console.log(response);
      if(response.data.code === 200){
         console.log("add Project successfull");
         setCount(count => count+1);
       }
      else{
        console.log("some error ocurred",response.data.code);
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  
 };

 const handleClick3 = e => {
    e.preventDefault();
  
     console.log("payload PP")
     var payload={
     "cid": selectedCustomer,
     "lid": selectedLocation,
     "pid": selectedProject,
      "project_code": projectCode
    }
     axios.post(apiBaseUrl+'/addProjectCode', payload)
    .then(function (response) {
      console.log(response);
      if(response.data.code === 200){
         console.log("add Project code successfull");
         setCount(count => count+1);
       }
      else{
        console.log("some error ocurred",response.data.code);
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  
 };

  return (
    <div className={classes.root}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography className={classes.heading}>Add a new customer name</Typography>
        </AccordionSummary>
        <AccordionDetails>
            <form className={classes.root} noValidate autoComplete="off">
    
               <TextField id="cname" label="Enter a new customer name" variant="outlined"  onChange = {e => setCname(e.target.value)} />
               <Button onClick={(event) =>handleClick(event)}>ADD</Button>
            </form>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography className={classes.heading}>Enter the location of the customer</Typography>
        </AccordionSummary>
        <AccordionDetails>
        <form className={classes.root} noValidate autoComplete="off">
           <p>Select The Customer Name</p>
               <Select onChange={e => setSelectedCustomer(e.target.value)}>{
                customerNames.map((obj) => {
                     return <MenuItem value={obj.id}>{obj.cname}</MenuItem>
                 })
                }</Select>
            <TextField id="location" label="Enter a Location" variant="outlined"  onChange = {e => setLocation(e.target.value)} />
            <Button onClick={(event) =>handleClick1(event)}>ADD Location</Button>

         </form>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography className={classes.heading}>Add a Project name</Typography>
        </AccordionSummary>
        <AccordionDetails>
            <form className={classes.root} noValidate autoComplete="off">
              <p>Select The Customer Name</p>
               <Select onChange={e => setSelectedCustomer(e.target.value)}>{
                customerNames.map((obj) => {
                     return <MenuItem value={obj.id}>{obj.cname}</MenuItem>
                 })
                }</Select><p>Select The location</p>
                <Select onChange={e => setSelectedLocation(e.target.value)}>{
                locationNames.code == 204 ? <MenuItem value="">" "</MenuItem>  : locationNames.map((obj) => {
                    return <MenuItem value={obj.id}>{obj.location}</MenuItem>
                })
                 }</Select>
               <TextField id="project_name" label="Enter a project name" variant="outlined"  onChange = {e => setPname(e.target.value)} />
               <Button onClick={(event) =>handleClick2(event)}>ADD</Button>
            </form>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography className={classes.heading}>Add a Project Code</Typography>
        </AccordionSummary>
        <AccordionDetails>
            <form className={classes.root} noValidate autoComplete="off">
              <p>Select The Customer Name</p>
               <Select onChange={e => setSelectedCustomer(e.target.value)}>{
                customerNames.map((obj) => {
                     return <MenuItem value={obj.id}>{obj.cname}</MenuItem>
                 })
                }</Select><p>Select The location</p>
                <Select onChange={e => setSelectedLocation(e.target.value)}>{
                locationNames.code == 204 ? <MenuItem value="">" "</MenuItem>  : locationNames.map((obj) => {
                    return <MenuItem value={obj.id}>{obj.location}</MenuItem>
                })
                 }</Select>
                <p>Select The Project name</p>
                <Select onChange={e => setSelectedProject(e.target.value)}>{
               projectNames.code == 204 ? <MenuItem value="">" "</MenuItem>  : projectNames.map((obj) => {
                     return <MenuItem value={obj.id}>{obj.project_name}</MenuItem>
                 })
              }</Select>
                
               <TextField id="project_code" label="Enter a Project code" variant="outlined"  onChange = {e => setPcode(e.target.value)} />
               <Button onClick={(event) =>handleClick3(event)}>ADD</Button>
            </form>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/ProjectDetails.js